/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Phase_PreviewingInputs */

const cs_import_progress_phase_previewing = /** @type {(inputs: Import_Progress_Phase_PreviewingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled`)
};

const en_import_progress_phase_previewing = /** @type {(inputs: Import_Progress_Phase_PreviewingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Import_Progress_Phase_PreviewingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_phase_previewing = /** @type {((inputs?: Import_Progress_Phase_PreviewingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Phase_PreviewingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_phase_previewing(inputs)
	return cs_import_progress_phase_previewing(inputs)
});